import type { PortableTextBlock } from "@portabletext/types";

export type Announcement = {
	_type: string;
	announcement: PortableTextBlock[];
	active: boolean;
	from?: string;
	to?: string;
};

export type AnnouncementResponse =
	| undefined
	| {
			data: Announcement | undefined;
	  };

export const fetchAnnouncement = async (
	sveltekitServerFetch?: typeof fetch
): Promise<AnnouncementResponse> => {
	const apiUrl = `/api/privat/varsel`;
	let res;
	let data;

	try {
		res = sveltekitServerFetch ? await sveltekitServerFetch(apiUrl) : await fetch(apiUrl);
		data = await res.json();
	} catch (e) {
		console.warn(e);
	}

	if (res?.ok && data) return data as AnnouncementResponse;
};
